module.exports = __webpack_public_path__ + "static/img/icon17.eb94a6a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon17.png
// module id = HhPr
// module chunks = 1